export default __webpack_public_path__ + "static/media/logo.fc857a89.svg";